import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
    Grid,
    Box,
    Divider,
    Typography,
    Stack
} from "@mui/material";
//constants
import Actions from '../constants/Actions';
//actions
import { removeFromCart, addItemQty, removeItemQty } from '../actions/index';
import Iconify from '../components/Iconify';
import "./Cart.css";
//components
import CartItemResumo from './CartItemResumo';
import { validaTotalGeral } from '../utils/functions';


const ItemSumary = ({ title, value, bold, highlight }) => {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center"
            sx={highlight ? {
                bgcolor: '#f8f9fa',
                mx: -2,
                px: 2,
                py: 1,
                borderRadius: 1,
            } : {}}
        >
            <Typography sx={{
                fontSize: highlight ? '0.95rem' : '0.85rem',
                color: highlight ? '#111' : '#666',
                fontWeight: highlight ? 700 : 400,
            }}>
                {title}
            </Typography>
            <Typography sx={{
                fontSize: highlight ? '1.1rem' : '0.9rem',
                fontWeight: bold || highlight ? 700 : 500,
                color: highlight ? '#111' : '#333',
            }}>
                {value}
            </Typography>
        </Stack>
    )
}

const CartResumo = ({ IrFrete }) => {
    const cartItems = useSelector(state => state.cartItems)
    const valorFrete = useSelector(state => state.valorFrete);
    const valorDesconto = useSelector(state => state.valorDesconto);
    const dispatch = useDispatch();

    const removerProdutoCarrinho = (product) => {
        dispatch(removeFromCart(product))
    }

    const adicionarQtdItemCarrinho = (product) => {
        dispatch(addItemQty(product))
    }

    const removerQtdItemCarrinho = (product) => {
        dispatch(removeItemQty(product))
    }

    const subtotal = cartItems.reduce((acc, { regular_price, quantity_inc }) => {
        let qty = 1;
        let item = parseFloat(regular_price).toFixed(2)
        let accumulator = parseFloat(acc).toFixed(2)
        let res = parseFloat(item) * qty + parseFloat(accumulator)
        return parseFloat(res).toFixed(2)
    }, 0);

    const total = validaTotalGeral(cartItems, valorFrete, valorDesconto);

    return (
        <Box>
            {/* Items list */}
            <Box sx={{ maxHeight: 320, overflowY: 'auto', pr: 0.5 }}>
                {cartItems.length > 0 ? (
                    <Stack spacing={1}>
                        {cartItems.map((cartItem) => (
                            <CartItemResumo
                                key={cartItem._id}
                                cartItem={cartItem}
                                removeFromCart={removerProdutoCarrinho}
                                addItemQty={adicionarQtdItemCarrinho}
                                removeItemQty={removerQtdItemCarrinho}
                            />
                        ))}
                    </Stack>
                ) : (
                    <Stack alignItems="center" justifyContent="center" sx={{ py: 4 }}>
                        <Iconify icon="mdi:cart-remove" color="#bbb" height="48" />
                        <Typography sx={{ mt: 1.5, color: '#999', fontSize: '0.85rem' }}>
                            Sem produtos no carrinho
                        </Typography>
                    </Stack>
                )}
            </Box>

            {/* Summary */}
            <Box sx={{ mt: 2.5 }}>
                <Divider sx={{ mb: 2 }} />
                <Stack spacing={1}>
                    <ItemSumary
                        title="Subtotal"
                        value={`R$ ${subtotal}`}
                    />
                    {valorDesconto > 0 && (
                        <ItemSumary
                            title="Desconto"
                            value={`- R$ ${valorDesconto}`}
                        />
                    )}
                    <ItemSumary
                        title="Frete"
                        value={valorFrete > 0 ? `R$ ${valorFrete}` : 'Grátis'}
                    />
                </Stack>

                <Divider sx={{ my: 1.5 }} />

                <ItemSumary
                    title="Total"
                    value={`R$ ${total}`}
                    highlight
                />
            </Box>
        </Box>
    )
}

export default CartResumo;
